import React from 'react'

export const badgeNumber = ({
    className = 'number',
    themeStyle = {},
    num = 10,
    size = 24
}) => {

  const defaultStyle = {
    backgroundColor: '#fff',
    border: 'solid 1px #777',
    padding: '2px',
    borderRadius: '50%',
    display: 'inline-block',
    fontSize: '12px',
    fontWeight: 600,
    height: size + 'px',
    width: size + 'px',
    textAlign: 'center',
    lineHeight:  size - 2 + 'px',
  }

  const numStyle = {
    ...defaultStyle,
    ...themeStyle,
  }

  const numDigits = num.toString().length
  if (numDigits > 2) {
    const baseFontSize = numStyle.fontSize.replace('px', '')
    numStyle.fontSize = baseFontSize - (numDigits - 1) + 'px'
  }

  return (
    <span className={className} style={numStyle}>
      {num}
    </span>
  )
}

export default badgeNumber
